module.exports = __webpack_public_path__ + "static/media/size-petite.8e9d91c2.svg";